import React, {memo} from "react"
import {doughnutOptions} from "../settings/options"
import {Doughnut} from "react-chartjs-2"
import {useHistory} from "react-router-dom"
import {useLocalization} from "../../../hooks/localization"
import useChartLoader from "../hooks/chart-loader"
import {ChartData} from "chart.js"
type Props = {
    data: ChartData<any>
    value: number
    page: number
}
export const DoughnutChart = memo(function DoughnutChart({data, value, page}: Props) {
    const history = useHistory()
    const {t} = useLocalization()
    const {isLoaded, loading} = useChartLoader()
    return (
        <div className="energy-box" onDoubleClick={() => history.push(`/energy/${page}`)}>
            {loading && (
                <div className="chart-spin-container">
                    <div className="chart-spin" />
                </div>
            )}
            <span style={isLoaded}>{t("energy_page.energy_consumption")}</span>
            <div className="energy-page" style={isLoaded}>
                <Doughnut data={data} options={doughnutOptions} />
                <span>{value}</span>
                <span>kW</span>
            </div>
        </div>
    )
})
